var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.549,
    height: 28.549,
    viewBox: "0 0 28.549 28.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone-alt",
    "data-name": "Icon awesome-phone-alt",
    d: "M.814,20.174,7.06,17.5a1.338,1.338,0,0,1,1.561.385l2.766,3.379a20.668,20.668,0,0,0,9.88-9.88L17.888,8.616A1.335,1.335,0,0,1,17.5,7.054L20.18.809A1.347,1.347,0,0,1,21.713.034l5.8,1.338a1.338,1.338,0,0,1,1.037,1.3A25.87,25.87,0,0,1,2.676,28.55a1.338,1.338,0,0,1-1.3-1.037l-1.338-5.8a1.354,1.354,0,0,1,.781-1.539Z",
    transform: "translate(0 0)",
    fill: "#ec6461"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFeatureIcon);
export default __webpack_public_path__ + "static/media/PhoneFeatureIcon.b8af72c8145aa9594b658c0c49cd7bfc.svg";
export { ForwardRef as ReactComponent };